import React from 'react';
import Svg from '../../Svg/Svg';
import { SvgProps } from '../../Svg';

const Icon: React.FC<SvgProps> = props => {
  return (
    <Svg
      width="136"
      height="48"
      viewBox="0 0 352 128"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10.9157 128C13.5308 128 16.1458 128 18.7608 128C123.586 128 228.413 128 333.238 128C335.853 128 338.469 128 341.084 128C342.589 128 344.094 128 345.598 128C346.103 128 346.59 127.943 347.08 127.827C347.316 127.769 347.548 127.7 347.776 127.617C348.696 127.284 349.448 126.805 350.138 126.11C350.235 126.012 350.328 125.912 350.419 125.808C350.533 125.677 350.642 125.542 350.746 125.402C350.753 125.392 350.76 125.381 350.768 125.371C351.015 125.033 351.224 124.679 351.4 124.299C351.408 124.283 351.416 124.266 351.424 124.249C351.431 124.232 351.439 124.215 351.447 124.197C351.455 124.181 351.461 124.164 351.469 124.146C351.491 124.096 351.513 124.044 351.534 123.992C351.538 123.981 351.544 123.967 351.548 123.955C351.645 123.711 351.725 123.465 351.792 123.211C351.794 123.202 351.796 123.195 351.798 123.186C351.932 122.661 351.998 122.14 351.998 121.599C351.998 117.333 351.998 113.067 351.998 108.799C351.998 74.6665 351.998 40.5331 351.998 6.3997C351.998 2.86518 349.133 0 345.598 0C344.094 0 342.589 0 341.084 0C339.869 0 338.654 0 337.438 0C337.405 0 337.371 0 337.337 0C337.287 0 337.237 0 337.188 0C335.871 0 334.554 0 333.238 0C228.412 0 123.585 0 18.7603 0C17.4434 0 16.1272 0 14.8109 0C14.7612 0 14.711 0 14.6613 0C14.6275 0 14.5936 0 14.5591 0C13.3445 0 12.1292 0 10.9145 0C9.40974 0 7.90498 0 6.40019 0C2.86566 0 0 2.86518 0 6.3997C0 40.5331 0 74.6665 0 108.799C0 113.067 0 117.333 0 121.599C0 125.134 2.86566 128 6.40019 128C7.90611 128 9.41091 128 10.9157 128Z"
        fill="#E3E3E3"
      />
      <path
        d="M0.0012207 108.4C0.0012207 108.534 0.0012207 108.666 0.0012207 108.799C0.0012207 113.067 0.0012207 117.333 0.0012207 121.6C0.0012207 125.134 2.8663 127.999 6.40196 127.999C7.90676 127.999 9.41158 127.999 10.9164 127.999C13.5314 127.999 16.1465 127.999 18.7609 127.999C48.9213 127.999 191.08 127.999 221.239 127.999C223.856 127.999 338.47 127.999 341.085 127.999C342.59 127.999 344.094 127.999 345.599 127.999C346.103 128 346.59 127.943 347.081 127.826C347.318 127.77 347.548 127.7 347.776 127.618C348.697 127.285 349.45 126.806 350.139 126.111C350.236 126.013 350.33 125.912 350.42 125.809C350.849 125.318 351.184 124.793 351.447 124.198C351.455 124.182 351.463 124.165 351.471 124.147C351.601 123.843 351.709 123.533 351.792 123.211C351.794 123.202 351.797 123.195 351.799 123.186C351.933 122.661 351.999 122.141 351.999 121.599C351.999 117.333 351.999 113.067 351.999 108.799C351.999 108.666 351.999 108.533 351.999 108.4H0.0012207V108.4Z"
        fill="url(#paint0_linear_6089_24439)"
      />
      <path
        opacity="0.2"
        d="M19.6007 0.000610352C19.3207 0.000610352 19.0407 0.000610352 18.7608 0.000610352C17.4445 0.000610352 16.1277 0.000610352 14.8114 0.000610352C14.7617 0.000610352 14.7115 0.000610352 14.6618 0.000610352C14.628 0.000610352 14.5941 0.000610352 14.5602 0.000610352C13.3449 0.000610352 12.1298 0.000610352 10.9151 0.000610352C9.4103 0.000610352 7.90547 0.000610352 6.40067 0.000610352C2.86558 0.000610352 0.000488281 2.86579 0.000488281 6.40031C0.000488281 40.5337 0.000488281 74.666 0.000488281 108.799C0.000488281 113.067 0.000488281 117.333 0.000488281 121.6C0.000488281 125.134 2.86558 127.999 6.40067 127.999C7.90547 127.999 9.4103 127.999 10.9151 127.999C13.5302 127.999 16.1457 127.999 18.7602 127.999C19.0402 127.999 19.3202 127.999 19.6001 127.999V0.000610352H19.6007Z"
        fill="url(#paint1_linear_6089_24439)"
      />
      <path
        opacity="0.2"
        d="M332.399 0.000610352C332.679 0.000610352 332.958 0.000610352 333.238 0.000610352C334.555 0.000610352 335.872 0.000610352 337.188 0.000610352C337.238 0.000610352 337.288 0.000610352 337.337 0.000610352C337.372 0.000610352 337.406 0.000610352 337.439 0.000610352C338.655 0.000610352 339.87 0.000610352 341.085 0.000610352C342.589 0.000610352 344.094 0.000610352 345.599 0.000610352C349.134 0.000610352 351.999 2.86579 351.999 6.40031C351.999 40.5337 351.999 74.666 351.999 108.799C351.999 113.067 351.999 117.333 351.999 121.6C351.999 125.134 349.134 127.999 345.599 127.999C344.094 127.999 342.589 127.999 341.085 127.999C338.47 127.999 335.854 127.999 333.239 127.999C332.959 127.999 332.68 127.999 332.4 127.999V0.000610352H332.399Z"
        fill="url(#paint2_linear_6089_24439)"
      />
      <path
        d="M332.143 108.4C332.323 108.4 332.398 108.325 332.398 108.145C332.398 78.7154 332.398 49.286 332.398 19.8567C332.398 19.676 332.323 19.6009 332.143 19.6009C302.713 19.6009 273.284 19.6009 243.855 19.6009C243.674 19.6009 243.599 19.676 243.599 19.8567C243.599 49.286 243.599 78.7154 243.599 108.145C243.599 108.325 243.674 108.4 243.855 108.4C273.284 108.4 302.713 108.4 332.143 108.4Z"
        fill="#575756"
      />
      <path
        d="M331.998 20.2568C331.998 49.4192 331.998 78.5822 331.998 107.745C331.998 107.925 331.923 108 331.742 108C302.58 108 273.418 108 244.255 108C244.075 108 244 107.925 244 107.745C244 78.5822 244 49.4192 244 20.2568C244 20.0762 244.075 20.001 244.255 20.001C273.418 20.001 302.58 20.001 331.742 20.001C331.923 20.0005 331.998 20.0756 331.998 20.2568Z"
        fill="#E3E3E3"
      />
      <path
        d="M257.407 53.1366C257.407 52.9559 257.482 52.8808 257.663 52.8808C266.757 52.8808 275.85 52.8808 284.943 52.8808C285.124 52.8808 285.199 52.9559 285.199 53.1366C285.199 60.3795 285.199 67.6217 285.199 74.8646C285.199 75.0453 285.124 75.1204 284.943 75.1204C275.85 75.1204 266.757 75.1204 257.663 75.1204C257.482 75.1204 257.407 75.0453 257.407 74.8646C257.407 67.6217 257.407 60.3795 257.407 53.1366Z"
        fill="#575756"
      />
      <path
        d="M291.055 75.1204C290.875 75.1204 290.8 75.0453 290.8 74.8646C290.8 67.6217 290.8 60.3795 290.8 53.1366C290.8 52.9559 290.875 52.8808 291.055 52.8808C300.148 52.8808 309.242 52.8808 318.335 52.8808C318.515 52.8808 318.59 52.9559 318.59 53.1366C318.59 60.3795 318.59 67.6217 318.59 74.8646C318.59 75.0453 318.515 75.1204 318.335 75.1204C309.242 75.1204 300.148 75.1204 291.055 75.1204Z"
        fill="#575756"
      />
      <path
        d="M284.543 74.7202C284.724 74.7202 284.799 74.6451 284.799 74.4645C284.799 67.4886 284.799 60.5121 284.799 53.5368C284.799 53.3556 284.724 53.2805 284.543 53.2805C275.716 53.2805 266.89 53.2805 258.063 53.2805C257.882 53.2805 257.807 53.3556 257.807 53.5368C257.807 60.5121 257.807 67.4886 257.807 74.4645C257.807 74.6451 257.882 74.7202 258.063 74.7202C266.89 74.7202 275.716 74.7202 284.543 74.7202Z"
        fill="#E3E3E3"
      />
      <path
        d="M317.935 74.7202C318.116 74.7202 318.191 74.6451 318.191 74.4645C318.191 67.4886 318.191 60.5121 318.191 53.5368C318.191 53.3556 318.116 53.2805 317.935 53.2805C309.108 53.2805 300.282 53.2805 291.456 53.2805C291.274 53.2805 291.199 53.3556 291.199 53.5368C291.199 60.5121 291.199 67.4886 291.199 74.4645C291.199 74.6451 291.274 74.7202 291.456 74.7202C300.282 74.7202 309.108 74.7202 317.935 74.7202Z"
        fill="#E3E3E3"
      />
      <path
        d="M315.408 89.8123C315.408 90.1521 315.548 90.2931 315.888 90.2931C316.102 90.2931 316.315 90.2931 316.528 90.2931C316.528 91.1561 316.528 92.0209 316.528 92.8839C314.648 92.8839 312.767 92.8839 310.888 92.8839C310.548 92.8839 310.407 93.025 310.407 93.3648C310.407 93.7046 310.548 93.8445 310.888 93.8445C311.556 93.8445 312.225 93.8445 312.894 93.8445C312.894 94.7076 312.894 95.5723 312.894 96.4354C312.681 96.4354 312.469 96.4354 312.255 96.4354C311.915 96.4354 311.775 96.5754 311.775 96.9152C311.775 97.2448 311.775 97.5744 311.775 97.9041C311.775 98.2438 311.915 98.385 312.255 98.385C313.001 98.385 313.748 98.385 314.494 98.385C314.834 98.385 314.974 98.2438 314.974 97.9041C314.974 97.5744 314.974 97.2448 314.974 96.9152C314.974 96.5754 314.834 96.4354 314.494 96.4354C314.281 96.4354 314.067 96.4354 313.854 96.4354C313.854 95.5723 313.854 94.7076 313.854 93.8445C315.957 93.8445 318.059 93.8445 320.161 93.8445C320.161 94.7076 320.161 95.5723 320.161 96.4354C319.949 96.4354 319.736 96.4354 319.522 96.4354C319.182 96.4354 319.042 96.5754 319.042 96.9152C319.042 97.2448 319.042 97.5744 319.042 97.9041C319.042 98.2438 319.182 98.385 319.522 98.385C320.268 98.385 321.015 98.385 321.761 98.385C322.101 98.385 322.241 98.2438 322.241 97.9041C322.241 97.5744 322.241 97.2448 322.241 96.9152C322.241 96.5754 322.101 96.4354 321.761 96.4354C321.548 96.4354 321.334 96.4354 321.121 96.4354C321.121 95.5723 321.121 94.7076 321.121 93.8445C321.791 93.8445 322.46 93.8445 323.129 93.8445C323.469 93.8445 323.609 93.7046 323.609 93.3648C323.609 93.025 323.469 92.8839 323.129 92.8839C321.248 92.8839 319.369 92.8839 317.488 92.8839C317.488 92.0209 317.488 91.1561 317.488 90.2931C317.701 90.2931 317.915 90.2931 318.128 90.2931C318.467 90.2931 318.607 90.1521 318.607 89.8123C318.607 89.4826 318.607 89.1529 318.607 88.8233C318.607 88.4835 318.467 88.3436 318.128 88.3436C317.382 88.3436 316.635 88.3436 315.889 88.3436C315.549 88.3436 315.409 88.4835 315.409 88.8233C315.408 89.1529 315.408 89.4826 315.408 89.8123Z"
        fill="#575756"
      />
      <path
        d="M280.903 59.5204V70.5607H261.703V59.5204H266.103V57.1203H267.704V55.2001H274.904V57.1203H276.504V59.5204H280.903Z"
        fill="#3C3C3B"
      />
      <path
        d="M281.623 55.2802H277.304V57.3597H281.623V55.2802Z"
        fill="#C6C6C6"
      />
      <path
        d="M265.304 55.2802H260.984V57.3597H265.304V55.2802Z"
        fill="#C6C6C6"
      />
      <path
        d="M314.296 59.5204V70.5607H295.094V59.5204H299.495V57.1203H301.095V55.2001H308.295V57.1203H309.895V59.5204H314.296Z"
        fill="#3C3C3B"
      />
      <path
        d="M315.015 55.2802H310.695V57.3597H315.015V55.2802Z"
        fill="#C6C6C6"
      />
      <path
        d="M298.695 55.2802H294.375V57.3597H298.695V55.2802Z"
        fill="#C6C6C6"
      />
      <path d="M298.695 70.5608V68.4803H299.459V70.5608" fill="#CA9E67" />
      <path d="M300.418 70.5608V68.4803H301.064V70.5608" fill="#CA9E67" />
      <path d="M302.025 70.5608V68.4803H302.67V70.5608" fill="#CA9E67" />
      <path d="M303.63 70.5608V68.4803H304.277V70.5608" fill="#CA9E67" />
      <path d="M305.237 70.5608V68.4803H305.883V70.5608" fill="#CA9E67" />
      <path d="M306.843 70.5608V68.4803H307.489V70.5608" fill="#CA9E67" />
      <path d="M308.449 70.5608V68.4803H309.096V70.5608" fill="#CA9E67" />
      <path d="M310.055 70.5608V68.4803H310.695V70.5608" fill="#CA9E67" />
      <path
        d="M277.304 68.4803H276.663V70.5608H277.304V68.4803Z"
        fill="#CA9E67"
      />
      <path
        d="M274.097 68.4803H273.451V70.5608H274.097V68.4803Z"
        fill="#CA9E67"
      />
      <path
        d="M272.491 68.4803H271.844V70.5608H272.491V68.4803Z"
        fill="#CA9E67"
      />
      <path
        d="M270.886 68.4803H270.24V70.5608H270.886V68.4803Z"
        fill="#CA9E67"
      />
      <path
        d="M269.279 68.4803H268.633V70.5608H269.279V68.4803Z"
        fill="#CA9E67"
      />
      <path
        d="M267.674 68.4803H267.027V70.5608H267.674V68.4803Z"
        fill="#CA9E67"
      />
      <path
        d="M266.067 68.4803H265.304V70.5608H266.067V68.4803Z"
        fill="#CA9E67"
      />
      <path
        d="M275.703 68.4803H275.057V70.5608H275.703V68.4803Z"
        fill="#CA9E67"
      />
      <path
        d="M19.8565 19.6008C19.6759 19.6008 19.6008 19.6759 19.6008 19.8577C19.6008 49.2871 19.6008 78.7159 19.6008 108.145C19.6008 108.326 19.6759 108.401 19.8565 108.401C49.2859 108.401 78.7147 108.401 108.144 108.401C108.326 108.401 108.4 108.326 108.4 108.145C108.4 78.7159 108.4 49.2871 108.4 19.8577C108.4 19.6759 108.326 19.6008 108.144 19.6008C78.7147 19.6008 49.2859 19.6008 19.8565 19.6008Z"
        fill="#575756"
      />
      <path
        d="M107.745 20.2568V20.0005H20.2573"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M107.744 20.0005C107.925 20.0005 108 20.0756 108 20.2563C108 49.4198 108 78.5822 108 107.745C108 107.925 107.925 108 107.744 108C78.5815 108 49.4191 108 20.2567 108C20.076 108 20.001 107.925 20.001 107.745C20.001 78.5822 20.001 49.4198 20.001 20.2563C20.001 20.0756 20.076 20.0005 20.2567 20.0005"
        fill="#E3E3E3"
      />
      <path
        d="M64.0003 94.8803C81.0545 94.8803 94.8797 81.0551 94.8797 64.0009C94.8797 46.9467 81.0545 33.1215 64.0003 33.1215C46.946 33.1215 33.1208 46.9467 33.1208 64.0009C33.1208 81.0551 46.946 94.8803 64.0003 94.8803Z"
        fill="url(#paint3_linear_6089_24439)"
      />
      <path
        d="M48.6407 68.5609C51.1592 68.5609 53.2008 66.5193 53.2008 64.0008C53.2008 61.4824 51.1592 59.4407 48.6407 59.4407C46.1222 59.4407 44.0806 61.4824 44.0806 64.0008C44.0806 66.5193 46.1222 68.5609 48.6407 68.5609Z"
        fill="#3C3C3B"
      />
      <path
        d="M79.3604 68.5609C81.8789 68.5609 83.9205 66.5193 83.9205 64.0008C83.9205 61.4824 81.8789 59.4407 79.3604 59.4407C76.8419 59.4407 74.8003 61.4824 74.8003 64.0008C74.8003 66.5193 76.8419 68.5609 79.3604 68.5609Z"
        fill="#3C3C3B"
      />
      <path
        d="M96.6689 98.0236C96.2569 98.4367 96.2569 99.1062 96.6689 99.5194C97.0832 99.9337 97.7503 99.9308 98.1635 99.5182C98.5772 99.1061 98.5778 98.4367 98.1646 98.0236C97.752 97.611 97.0821 97.611 96.6689 98.0236Z"
        fill="#575756"
      />
      <path
        d="M93.6537 98.2918C92.9216 98.2918 92.1895 98.2918 91.4574 98.2918C91.3282 98.2918 91.2757 98.2387 91.2757 98.11C91.2757 96.345 91.2757 94.5799 91.2757 92.8149C91.2757 92.6857 91.3288 92.6332 91.4574 92.6332C93.2225 92.6332 94.9874 92.6332 96.7525 92.6332C96.8811 92.6332 96.9337 92.6862 96.9342 92.8149C96.9342 93.547 96.9342 94.2791 96.9342 95.0123C96.9342 95.3521 97.0742 95.4922 97.414 95.4922C97.7538 95.4922 97.8949 95.3521 97.8949 95.0123C97.8949 94.2791 97.8949 93.547 97.8949 92.8149C97.8938 92.1845 97.3829 91.6742 96.753 91.6731C94.988 91.6731 93.223 91.6731 91.458 91.6731C90.8275 91.6731 90.3162 92.1845 90.3162 92.8149C90.3162 94.5799 90.3162 96.345 90.3162 98.11C90.3162 98.7405 90.8275 99.2518 91.458 99.2518C92.1901 99.2518 92.9222 99.2518 93.6542 99.2518C93.9929 99.2518 94.134 99.1118 94.134 98.772C94.134 98.4322 93.9923 98.2918 93.6537 98.2918Z"
        fill="#575756"
      />
      <path
        d="M67.1205 41.6005V33.2879C66.0887 33.183 65.0484 33.1202 64.0003 33.1202C62.9476 33.1202 61.9068 33.1745 60.8806 33.2766V41.5999H67.1205V41.6005Z"
        fill="#3C3C3B"
      />
      <path
        d="M37.6002 59.311C37.6002 55.532 37.6002 51.7526 37.6002 47.9736C35.4548 51.5003 34.0042 55.493 33.4177 59.7607C34.6618 59.7607 35.9058 59.7607 37.1504 59.7607C37.4682 59.7607 37.6002 59.6293 37.6002 59.311Z"
        fill="#D0D0D0"
      />
      <path
        d="M90.8937 59.7607C92.1248 59.7607 93.3564 59.7607 94.588 59.7607C94.5801 59.7077 94.5728 59.6541 94.5649 59.601C94.557 59.5479 94.5496 59.4943 94.5417 59.4413C93.9524 55.4936 92.7214 51.9755 90.7204 48.5216C90.6188 48.3472 90.5042 48.1807 90.4004 48.0092C90.4004 51.7616 90.4004 55.5157 90.4004 59.2681C90.4004 59.6163 90.5449 59.7607 90.8937 59.7607Z"
        fill="#D0D0D0"
      />
      <path
        d="M60.8806 86.4006V94.7239C61.9068 94.8267 62.9476 94.8803 64.0003 94.8803C65.0535 94.8803 66.0943 94.8261 67.1205 94.7239V86.4006H60.8806Z"
        fill="#3C3C3B"
      />
      <path
        d="M37.0742 68.2404C35.8556 68.2404 34.6369 68.2404 33.4177 68.2404C34.0042 72.5092 35.4548 76.5008 37.6002 80.0275C37.6002 76.2739 37.6002 72.521 37.6002 68.7675C37.6002 68.3949 37.4462 68.2404 37.0742 68.2404Z"
        fill="#D0D0D0"
      />
      <path
        d="M91.0122 68.2404C90.5793 68.2404 90.4004 68.4199 90.4004 68.8511C90.4004 72.5775 90.4004 76.3022 90.4004 80.0275C92.5458 76.5008 93.9965 72.5092 94.5829 68.2404C93.3931 68.2404 92.2026 68.2404 91.0122 68.2404Z"
        fill="#D0D0D0"
      />
      <path
        d="M62.1038 94.8104C62.7337 94.851 63.3653 94.8809 64.0009 94.8809C64.6387 94.8809 65.2692 94.8544 65.8974 94.816V85.2723H62.1033V94.8104H62.1038Z"
        fill="url(#paint4_linear_6089_24439)"
      />
      <path
        d="M65.8973 33.1915C65.2674 33.1509 64.6358 33.121 64.0003 33.121C63.3625 33.121 62.732 33.1475 62.1038 33.1859V42.7294H65.8979V33.1915H65.8973Z"
        fill="url(#paint5_linear_6089_24439)"
      />
      <path
        d="M131.856 19.6009C131.675 19.6009 131.6 19.676 131.6 19.8578C131.6 49.2871 131.6 78.7159 131.6 108.145C131.6 108.326 131.675 108.401 131.856 108.401C161.285 108.401 190.714 108.401 220.143 108.401C220.325 108.401 220.399 108.326 220.399 108.145C220.399 78.7159 220.399 49.2871 220.399 19.8578C220.399 19.676 220.325 19.6009 220.143 19.6009C190.714 19.6009 161.284 19.6009 131.856 19.6009Z"
        fill="#575756"
      />
      <path
        d="M219.744 20.2569V20.0005H132.256"
        stroke="#010202"
        strokeWidth="0.2835"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M219.743 20.0005C219.924 20.0005 219.999 20.0757 219.999 20.2563C219.999 49.4198 219.999 78.5822 219.999 107.745C219.999 107.925 219.924 108 219.743 108C190.58 108 161.418 108 132.256 108C132.075 108 132 107.925 132 107.745C132 78.5822 132 49.4198 132 20.2563C132 20.0757 132.075 20.0005 132.256 20.0005"
        fill="#E3E3E3"
      />
      <path
        d="M175.999 94.8804C193.054 94.8804 206.879 81.0552 206.879 64.001C206.879 46.9468 193.054 33.1216 175.999 33.1216C158.945 33.1216 145.12 46.9468 145.12 64.001C145.12 81.0552 158.945 94.8804 175.999 94.8804Z"
        fill="url(#paint6_linear_6089_24439)"
      />
      <path
        d="M160.64 68.561C163.158 68.561 165.2 66.5195 165.2 64.001C165.2 61.4825 163.158 59.4408 160.64 59.4408C158.121 59.4408 156.08 61.4825 156.08 64.001C156.08 66.5195 158.121 68.561 160.64 68.561Z"
        fill="#3C3C3B"
      />
      <path
        d="M191.359 68.561C193.878 68.561 195.92 66.5195 195.92 64.001C195.92 61.4825 193.878 59.4408 191.359 59.4408C188.841 59.4408 186.799 61.4825 186.799 64.001C186.799 66.5195 188.841 68.561 191.359 68.561Z"
        fill="#3C3C3B"
      />
      <path
        d="M208.668 98.0237C208.256 98.4369 208.256 99.1064 208.668 99.5195C209.082 99.9338 209.749 99.9309 210.163 99.5183C210.576 99.1063 210.577 98.4369 210.164 98.0237C209.751 97.6111 209.081 97.6111 208.668 98.0237Z"
        fill="#575756"
      />
      <path
        d="M205.653 98.2919C204.921 98.2919 204.189 98.2919 203.456 98.2919C203.327 98.2919 203.275 98.2388 203.275 98.1101C203.275 96.3451 203.275 94.5801 203.275 92.8151C203.275 92.6858 203.328 92.6333 203.456 92.6333C205.221 92.6333 206.987 92.6333 208.752 92.6333C208.88 92.6333 208.933 92.6864 208.933 92.8151C208.933 93.5471 208.933 94.2792 208.933 95.0125C208.933 95.3523 209.073 95.4923 209.413 95.4923C209.753 95.4923 209.894 95.3523 209.894 95.0125C209.894 94.2792 209.894 93.5471 209.894 92.8151C209.893 92.1846 209.382 91.6743 208.752 91.6732C206.987 91.6732 205.222 91.6732 203.457 91.6732C202.827 91.6732 202.315 92.1846 202.315 92.8151C202.315 94.5801 202.315 96.3451 202.315 98.1101C202.315 98.7406 202.827 99.252 203.457 99.252C204.189 99.252 204.921 99.252 205.653 99.252C205.992 99.252 206.133 99.1119 206.133 98.7721C206.133 98.4323 205.991 98.2919 205.653 98.2919Z"
        fill="#575756"
      />
      <path
        d="M179.119 41.6005V33.2879C178.088 33.183 177.047 33.1202 175.999 33.1202C174.946 33.1202 173.906 33.1745 172.879 33.2766V41.5999H179.119V41.6005Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.599 59.311C149.599 55.532 149.599 51.7526 149.599 47.9736C147.454 51.5003 146.003 55.493 145.417 59.7607C146.661 59.7607 147.905 59.7607 149.149 59.7607C149.467 59.7607 149.599 59.6293 149.599 59.311Z"
        fill="#D0D0D0"
      />
      <path
        d="M202.893 59.7607C204.124 59.7607 205.355 59.7607 206.587 59.7607C206.579 59.7077 206.572 59.6541 206.564 59.601C206.556 59.5479 206.549 59.4943 206.541 59.4413C205.951 55.4936 204.72 51.9755 202.719 48.5216C202.618 48.3472 202.503 48.1807 202.399 48.0092C202.399 51.7616 202.399 55.5157 202.399 59.2681C202.399 59.6163 202.544 59.7607 202.893 59.7607Z"
        fill="#D0D0D0"
      />
      <path
        d="M172.879 86.4006V94.7239C173.905 94.8267 174.946 94.8803 175.999 94.8803C177.052 94.8803 178.093 94.8261 179.119 94.7239V86.4006H172.879Z"
        fill="#3C3C3B"
      />
      <path
        d="M149.073 68.2404C147.855 68.2404 146.636 68.2404 145.417 68.2404C146.003 72.5092 147.454 76.5008 149.599 80.0275C149.599 76.2739 149.599 72.521 149.599 68.7675C149.599 68.3949 149.445 68.2404 149.073 68.2404Z"
        fill="#D0D0D0"
      />
      <path
        d="M203.011 68.2404C202.578 68.2404 202.399 68.4199 202.399 68.8511C202.399 72.5775 202.399 76.3022 202.399 80.0275C204.545 76.5008 205.995 72.5092 206.582 68.2404C205.392 68.2404 204.202 68.2404 203.011 68.2404Z"
        fill="#D0D0D0"
      />
      <path
        d="M174.102 94.8105C174.732 94.8511 175.364 94.881 175.999 94.881C176.637 94.881 177.268 94.8545 177.896 94.8161V85.2725H174.102V94.8105H174.102Z"
        fill="url(#paint7_linear_6089_24439)"
      />
      <path
        d="M177.896 33.1915C177.267 33.1509 176.635 33.121 175.999 33.121C175.362 33.121 174.731 33.1475 174.103 33.1859V42.7294H177.897V33.1915H177.896Z"
        fill="url(#paint8_linear_6089_24439)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6089_24439"
          x1="176"
          y1="109.077"
          x2="176"
          y2="127.44"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="#D9D9D9" stopOpacity="0" />
          <stop offset="0.2624" stopColor="#E5E5E5" stopOpacity="0.5" />
          <stop offset="0.5198" stopColor="#EBEBEB" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_6089_24439"
          x1="16.5595"
          y1="64"
          x2="0.308842"
          y2="64"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_6089_24439"
          x1="335.441"
          y1="63.9995"
          x2="351.691"
          y2="63.9995"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.005" stopColor="white" stopOpacity="0" />
          <stop offset="0.5297" />
        </linearGradient>
        <linearGradient
          id="paint3_linear_6089_24439"
          x1="64.0004"
          y1="94.8806"
          x2="64.0004"
          y2="33.1207"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint4_linear_6089_24439"
          x1="64.0006"
          y1="94.7484"
          x2="64.0006"
          y2="85.2432"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint5_linear_6089_24439"
          x1="64.0005"
          y1="33.2531"
          x2="64.0005"
          y2="42.7581"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint6_linear_6089_24439"
          x1="175.999"
          y1="94.8808"
          x2="175.999"
          y2="33.1208"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C6C6C6" />
          <stop offset="0.2003" stopColor="#C0C0C0" />
          <stop offset="0.5079" stopColor="#AFAFAF" />
          <stop offset="0.8825" stopColor="#929291" />
          <stop offset="1" stopColor="#878787" />
        </linearGradient>
        <linearGradient
          id="paint7_linear_6089_24439"
          x1="176"
          y1="94.7485"
          x2="176"
          y2="85.2433"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
        <linearGradient
          id="paint8_linear_6089_24439"
          x1="175.999"
          y1="33.2531"
          x2="175.999"
          y2="42.7581"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#716033" />
          <stop offset="0.0653" stopColor="#796637" />
          <stop offset="0.1656" stopColor="#8B7640" />
          <stop offset="0.2885" stopColor="#A98E4E" />
          <stop offset="0.4279" stopColor="#CFAD5E" />
          <stop offset="0.4604" stopColor="#D9B562" />
          <stop offset="0.5059" stopColor="#DEBA6B" />
          <stop offset="0.5755" stopColor="#EBC983" />
          <stop offset="0.6188" stopColor="#F5D597" />
          <stop offset="0.6799" stopColor="#F1D08E" />
          <stop offset="0.7734" stopColor="#E3C075" />
          <stop offset="0.8317" stopColor="#D9B562" />
          <stop offset="0.8632" stopColor="#D3B060" />
          <stop offset="0.9116" stopColor="#C2A259" />
          <stop offset="0.9706" stopColor="#A68C4C" />
          <stop offset="1" stopColor="#957E45" />
        </linearGradient>
      </defs>
    </Svg>
  );
};

export default Icon;
